/**
 * StoragePort implementation: localStorage (contracts.md, ADR-4).
 */

import type {
  StoragePort,
  SaveResult,
  SaveData,
} from "../../application/ports.js";
import { activeCampaign, type CampaignConfig } from "../../campaign/index.js";

export function createLocalStorageAdapter(campaign: CampaignConfig = activeCampaign): StoragePort {
  const storageKey = campaign.storageKey;
  return {
    async load(): Promise<SaveData | null> {
      try {
        const raw = localStorage.getItem(storageKey);
        if (raw === null) return null;
        const data = JSON.parse(raw) as unknown;
        return data as SaveData;
      } catch {
        return null;
      }
    },
    async save(data: SaveData): Promise<SaveResult> {
      try {
        localStorage.setItem(storageKey, JSON.stringify(data));
        return { ok: true };
      } catch {
        return { ok: false, code: "STORAGE_ERROR" };
      }
    },
  };
}
